/**
 * Cards for the most recent reviews where grade < 3. Each card surfaces
 * the comment + driver + technician(s) so the operator can spot a problem
 * fast and click through to the service detail (TODO once routing
 * provides the path).
 *
 * Loading state shows skeleton placeholders so the section doesn't
 * disappear during refetch.
 */
import { useHistory } from "react-router-dom";

import ChartCard from "../ChartCard/ChartCard";
import Stars from "../Stars/Stars";
import { formatDateTime } from "../../../../../constants/analytics.constants";
import {
  RecentLowRatingsStyles,
  Skeleton
} from "./recentLowRatings.styles";

const RecentLowRatings = ({
  data = [],
  loading = false,
  serviceTypes = []
}) => {
  const history = useHistory();

  const labelById = serviceTypes.reduce((acc, t) => {
    acc[t.id] = t.name || t.key || `Type #${t.id}`;
    return acc;
  }, {});

  return (
    <ChartCard
      title="Recent low ratings"
      subtitle="Reviews with grade < 3 — click to open service"
    >
      {loading ? (
        <RecentLowRatingsStyles>
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="lowrate-card lowrate-card--skeleton">
              <Skeleton style={{ width: "35%", height: 14 }} />
              <Skeleton style={{ width: "100%", height: 12, marginTop: 8 }} />
              <Skeleton style={{ width: "60%", height: 12, marginTop: 6 }} />
            </div>
          ))}
        </RecentLowRatingsStyles>
      ) : data.length === 0 ? (
        <div style={{ padding: 24, textAlign: "center", color: "#8E8E8E", fontSize: 12 }}>
          No low-rating reviews — nice work
        </div>
      ) : (
        <RecentLowRatingsStyles>
          {data.map(r => (
            <a
              key={r.reviewId}
              href={`/services/${r.serviceId}`}
              className="lowrate-card"
              onClick={e => {
                // SPA navigation — preserves React state and avoids the
                // full page reload that would happen with the default
                // anchor behaviour or window.location.assign().
                e.preventDefault();
                history.push(`/services/${r.serviceId}`);
              }}
            >
              <div className="lowrate-head">
                <div className="lowrate-grade">
                  <Stars value={r.grade} size={12} />
                  <span className="lowrate-svc">
                    {labelById[r.serviceTypeId] || `Type #${r.serviceTypeId}`}
                  </span>
                  <span className="lowrate-id">· S-{r.serviceId}</span>
                </div>
                <span className="lowrate-time">{formatDateTime(r.createdAt)}</span>
              </div>
              {r.comment && <p className="lowrate-text">"{r.comment}"</p>}
              <div className="lowrate-meta">
                <span>
                  <b>Driver:</b>{" "}
                  {r.driverFirstName || r.driverLastName
                    ? `${r.driverFirstName || ""} ${r.driverLastName || ""}`.trim()
                    : "—"}
                </span>
                {r.technicians && r.technicians.length > 0 && (
                  <span>
                    <b>Tech:</b> {r.technicians.join(", ")}
                  </span>
                )}
              </div>
            </a>
          ))}
        </RecentLowRatingsStyles>
      )}
    </ChartCard>
  );
};

export default RecentLowRatings;
